import { connect, Dispatch } from 'react-redux';
import { App, AppActionProps, AppProps } from './component';
import { AppState } from './state';
import { ListAlertsAction } from 'components/main/actions';
import { RefreshTokenAction } from 'pages/login/actions';
import { GetTenantIdExistsAction, GetTenantFromCacheAction } from 'pages/settings/actions';
import { areAllTermsAccepted } from 'pages/terms-of-use/selectors';
import { Action } from 'helpers/action-helpers';
import { withRouter } from 'react-router';
import { ListOperationItemsAction } from 'components/operation-grid/actions';

function mapStateToProps(state: AppState): AppProps {

  const hasEnterpriseLogin = state.settings.tenant
    ? state.settings.tenant.hasEnterpriseLogin
    : undefined;

  return {
    permissions: state.login.permissions,
    loggedIn: state.login.loggedIn as boolean,
    hasEnterpriseLogin: hasEnterpriseLogin,
    tenantIdExists: state.settings.tenantIdExists as boolean,
    termsAccepted: areAllTermsAccepted(state)
  };
}

function mapDisptachToProps(dispatch: Dispatch<Action>): AppActionProps {
  return {
    listRows: () => dispatch(new ListOperationItemsAction()),
    listAlerts: () => dispatch(new ListAlertsAction()),
    getTenantIdExists: () => dispatch(new GetTenantIdExistsAction()),
    getTenantFromCache: () => dispatch(new GetTenantFromCacheAction()),
    refresh: () => dispatch(new RefreshTokenAction())
  };
}

export default withRouter(connect(mapStateToProps, mapDisptachToProps)(App));



// WEBPACK FOOTER //
// ./src/pages/app/index.ts